import classNames from 'classnames'
import { GetServerSideProps } from 'next'
import { useMemo } from 'react'
import { useCookies } from 'react-cookie'

import Container from '@/components/Container/Container'
import { ExplicitHead } from '@/components/DefaultHead/DefaultHead'
import Main from '@/components/Main/Main'
import Panel from '@/components/Panel/Panel'
import SaltBody from '@/components/Salt/SaltBody'
import SaltVoteCount from '@/components/Salt/SaltVoteCount'
import SimpleHeader from '@/components/SimpleHeader/SimpleHeader'
import { useAppSelector } from '@/store/hooks'
import { userIsBanned } from '@/utils/helpers.server'

import styles from './salt.module.scss'

let FINISHED = true

type Props = {
  initCountry?: string
  initRegion?: string
}

const Privacy = () => {
  const [cookies] = useCookies(['count', 'total'])
  const voteCount = useMemo(() => Number(cookies.count) || 0, [cookies.count])

  // Enable salt vote for admins and specific testers
  const isSaltTester = useAppSelector(
    (state) => state.user.isAdmin || ['david.keatts@gmail.com'].includes(state.user.email),
  )
  if (isSaltTester) FINISHED = false

  return (
    <Main>
      <Container>
        <ExplicitHead description='EDHREC Salt Vote' keywords='EDHREC,salt,score,vote' title='Salt Vote | EDHREC' />
        <div className='align-items-end d-flex mb-2'>
          <SimpleHeader>Salt Vote</SimpleHeader>
          {!FINISHED && <SaltVoteCount voteCount={voteCount} />}
        </div>
        <Panel className={classNames({ [styles.panel]: !FINISHED })}>
          {FINISHED ? (
            <div className={styles.info}>
              <h2 className='mb-3'>Thank you!</h2>
              <p>
                That&apos;s all for this round of salt voting. Keep and eye on EDHREC and Archidekt for the updated
                results once we process the data. If you are sad to see the polls end, don&apos;t worry! We&apos;ll be
                back for more salt voting and other data collection soon.
              </p>
              <p>Thanks for joining us in the salt mines!</p>
            </div>
          ) : (
            <SaltBody voteCount={voteCount} />
          )}
        </Panel>
        {!FINISHED && cookies.total && (
          <div className='d-flex justify-content-center'>
            <div className={styles.voteCount}>
              {cookies.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} votes
              {!FINISHED && <span> so far</span>}
            </div>
          </div>
        )}
      </Container>
    </Main>
  )
}

export const getServerSideProps: GetServerSideProps<Props> = async ({ req }) => {
  if (userIsBanned(req.headers)) return { redirect: { destination: '/access-restricted', permanent: false } }
  const props: Props = {}
  if (req.headers['cloudfront-viewer-country']) props.initCountry = req.headers['cloudfront-viewer-country'] as string
  if (req.headers['cloudfront-viewer-country-region'])
    props.initRegion = req.headers['cloudfront-viewer-country-region'] as string
  return { props }
}

export default Privacy
